module.exports = __webpack_public_path__ + "img/icon_refresh.d02742bb.png";